import React, {useState} from 'react';
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {Portlet, PortletBody, PortletFooter, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import Select from "react-select";
import {Button, Col, Form} from "react-bootstrap";
import {Row} from "reactstrap";
import {useForm} from "react-hook-form";
import clsx from "clsx";
import axios from "../../../helpers/axios";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import sayError from "../../../helpers/sayError";
import moment from "moment";
import {Helmet} from "react-helmet";
import RacoonResultRoute from "../components/racoonResultRoute";
import BlockUi from "@availity/block-ui";

const types = {
  'ak': {
    inputs:[
      {label: 'Начало периода', name: 'start'},
      {label:'Конец периода', name: 'end'}],
    url: '/api/racoon/pdfParse/operativeAruanaKauar'
  },
  'ks': {
    inputs:[{label: 'Silk', name: 'silk', firstPeriod: 'silk', secondPeriod: 'kayar'}],
    url: 'api/racoon/pdfParse/operativeSilkKayar'
  },
  'ai': {
    inputs:[{label: 'Iata', name: 'iata', firstPeriod: 'aruana', secondPeriod: 'iata'}],
    url: '/api/racoon/pdfParse/operativeIataAruana'
  },
  'kg': {
    inputs:[
      {label: 'Начало периода', name: 'start'},
      {label:'Конец периода', name: 'end'}],
    url:'/api/racoon/pdfParse/checkKayarGoogle'
  },
  'sk':{
    inputs:[
      {label: 'Начало периода', name: 'start'},
      {label:'Конец периода', name: 'end'}],
    url: '/api/racoon/pdfParse/checkKayarSite'
  },
  'yk':{
    inputs:[
      {label: 'Начало периода', name: 'start'},
      {label:'Конец периода', name: 'end'}],
    url: '/api/racoon/pdfParse/operativeKayarYana'
  },
  'rh': {
    inputs:[{label: 'Ratehawk', name: 'ratehawk', firstPeriod: 'kayar', secondPeriod: 'ratehawk'}],
    url: '/api/racoon/pdfParse/checkKayarRatehawk'
  },
  'kt': {
    inputs:[{label: 'Трансавиа', name: 'transavia', firstPeriod: 'kayar', secondPeriod: 'transavia'}],
    url: '/api/racoon/pdfParse/operativeTransaviaKayar'
  },
}
const FastCheck = () => {
  const [type, setType] = useState(null)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const defaultVal= {
    start: moment().subtract(7, 'days').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY'),
  }

  console.log(type && types[type])
  const formController = useForm();
  const { control,
    register,
    handleSubmit, reset,
    getValues
  } = formController;
  const renderInputs = (type)=>{
    return types[type].inputs.map((t,i)=>{
      if(type === "ak" || type === "sk" || type === "yk" || type === "kg" ){
        return <Col key={i} sm={2}>
          <CustomDatePicker formController={formController}
                            value={defaultVal[t.name]}
                            label={t.label}
                            name={t.name}
                            rules={{required: true}}/>
        </Col>
      }
      return <>
        <Col key={i}>
          <Form.Label>{t.label}</Form.Label>
          <Form.Control
            type={"file"}
            accept={'.xlsx'}
            multiple={true}
            {...register(t.name, {required: true})}
          />
        </Col>
        {type === "ks" && <Col xs={1}>
          <Form.Label className={'d-flex align-items-center gap-2'}>
            <input
              defaultChecked={false}
              {...register(`commissionsRevise`)}
              type={"checkbox"}
            />{" "}
            С ЭСФ
          </Form.Label>
        </Col>}
      </>

    })
  }
  const onSubmit = (data) =>{
    setData(null)
    console.log("data", data)
    setLoading(true)
    let dataF;
    if(type === "ak" || type === "sk"  || type === "yk" || type === "kg"){
      dataF = data
      if(data.start.slice(-4)!==data.end.slice(-4)){
        setError(true)
        setLoading(false)
        return
      }
    }else{
      dataF = new FormData();
      Object.keys(data).map((key,i)=>{
        let x = 0
        while (x < data[key].length) {
          dataF.append(`${key}${type === "rh" || type === "kt"  ? "":x}`, data[key][x]);
          x++;
        }
      })
    }

    let pass = types[type].url
    const commissionsRevise = data.commissionsRevise
    if(commissionsRevise){
      dataF.append("commissionsRevise", commissionsRevise)
    }
    axios
      .post(pass, dataF, {headers: {
          'Content-Type':"application/x-www-form-urlencoded"}}).then(({data})=>{
      if(commissionsRevise) data.commissionsRevise = commissionsRevise
      setData(data)
    })
      .catch(sayError)
      .finally(()=>{setLoading(false)})
  }
  const reloadCheck = () => {
    const values = getValues()
    if (!values.start || !values.end || values.start.slice(-4) !== values.end.slice(-4)) {
      setError(true)
      return
    }
    setError(false)
    setLoading(true)
    axios.post(types[type].url, values, {headers: {
        'Content-Type': "application/x-www-form-urlencoded"
      }})
      .then(({data}) => setData(data))
      .catch(sayError)
      .finally(() => setLoading(false))
  }
  return (
    <>
      <Helmet>
        <title>Быстрая сверка</title>
      </Helmet>
      <Paper elevation={0} style={{ marginBottom: 15 }}>
        <Breadcrumbs aria-label="Breadcrumb" style={{padding: 15}}>
          <Typography color="textPrimary">Быстрые сверки </Typography>
          <a
            href="https://convertio.co/ru/xls-xlsx/"
            target={"_blank"}
            referrerPolicy={"no-referrer"}
          >
            Конвертер xls в xlsx
          </a>
          <a
            className={"mr-3"}
            href="https://www.pdf2go.com/ru/pdf-to-excel"
            target={"_blank"}
            referrerPolicy={"no-referrer"}
          >
            Конвертер pdf в xlsx
          </a>
        </Breadcrumbs>
      </Paper>
      <Portlet>
        <PortletHeader title={"Все файлы из 1C должны выгруждаться только в формате XSLX"} toolbar={
          <PortletHeaderToolbar>
            <div style={{width: 250}}>
              <Select
                options={[
                  {value: 'ak',label:'Aruana - Kayar'},
                  {value: 'ks',label:'Kayar - Silk'},
                  {value: 'ai',label:'Aruana - Iata'},
                  {value: 'kg',label:'Kayar - Google'},
                  {value: 'sk',label:'Site - 1C'},
                  {value: 'yk',label:'Kayar - Yana'},
                  {value: 'rh',label:'Kayar - RateHawk'},
                  {value: 'kt',label:'Kayar - Трансавиа'},
                ]}
                onChange={(val)=> {
                  console.log('select',val)
                  setType(val.value)
                  reset()
                  setData(null)
                }}
              />
            </div>

          </PortletHeaderToolbar>
        } />
        <>
          <PortletBody>

          {type ?
            <>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Row className={'align-items-end'}>
                      {renderInputs(type)}
                      <Col>
                        <Button
                          onClick={handleSubmit(onSubmit)}
                          className={` ${clsx({
                            "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                          })}`}
                        >
                          Сравнить
                        </Button>
                      </Col>
                    </Row>
                    {error && <p className={'text-danger'}>Период должен быть в пределах 1 года</p>}
                  </form>
            </> :
            <PortletBody>
              Пожалуйста, выберите тип сверки
            </PortletBody>}
            <BlockUi blocking={loading}>
              {data &&
                <RacoonResultRoute
                  type={data.commissionsRevise ? 'ssk' : type}
                  data={data}
                  onReload={type === 'yk' ? reloadCheck : undefined}
                />}
            </BlockUi>
          </PortletBody>
        </>

      </Portlet>
    </>
  );
};

export default FastCheck;



